export default __webpack_public_path__ + "static/media/deposit.6305de8e.mp3";